import { Action } from "redux";
import { ofType, Epic, combineEpics } from "redux-observable";
import { mergeMap } from "rxjs";
import { IAction } from "../../../interface/action.interface";
import { IRootState } from "../../../redux/root.reducer";
import { announcementsActions, announcementsEpic } from "./announcements";
import { historyActions, historyEpic } from "./history";
import { HomeActionType } from "./home.actions";

const epic: Epic<IAction, IAction, IRootState> = (action$) =>
    action$.pipe(
        ofType<Action, string>(HomeActionType.HOME_PAGE_INIT),
        mergeMap(() => [announcementsActions.init(), historyActions.init()]),
    );

export const homeEpic = combineEpics<IAction, IAction, IRootState>(
    epic,
    announcementsEpic,
    historyEpic,
);
